export default __webpack_public_path__ + "static/media/tror_white.80e2d196.png";